import { useMemo } from 'react';
import { motion } from 'framer-motion';
import { BADGE_DEFINITIONS } from '../utils/badges';

export default function BadgesPanel({ skills, scores, lessonCount }) {
    const badgeData = useMemo(() => {
        const data = { skills, scores, lessonCount };
        return BADGE_DEFINITIONS.map(badge => ({
            ...badge,
            earned: badge.check(data),
        }));
    }, [skills, scores, lessonCount]);

    const earnedCount = badgeData.filter(b => b.earned).length;

    return (
        <div>
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Achievements
                </h3>
                <span className="text-sm text-[#D4A537] font-medium">
                    {earnedCount} / {BADGE_DEFINITIONS.length}
                </span>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
                {badgeData.map((badge, index) => {
                    const Icon = badge.icon;
                    return (
                        <motion.div
                            key={badge.id}
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ delay: index * 0.05 }}
                            className={`relative p-4 rounded-lg border-2 text-center transition-all ${
                                badge.earned
                                    ? 'border-[#D4A537] bg-[#D4A537]/10'
                                    : 'border-[#4A5568] bg-[#1A202C] opacity-40'
                            }`}
                            data-testid={`badge-${badge.id}`}
                        >
                            <div className={`mx-auto w-10 h-10 rounded-full flex items-center justify-center mb-2 ${
                                badge.earned ? 'bg-[#D4A537]/20' : 'bg-[#2D3748]'
                            }`}>
                                <Icon 
                                    size={24} 
                                    weight={badge.earned ? "fill" : "regular"}
                                    className={badge.earned ? 'text-[#D4A537]' : 'text-gray-600'}
                                />
                            </div>
                            <div className={`text-xs font-bold ${badge.earned ? 'text-white' : 'text-gray-600'}`}>
                                {badge.name}
                            </div>
                            <div className={`text-xs mt-1 ${badge.earned ? 'text-gray-400' : 'text-gray-700'}`}>
                                {badge.description}
                            </div>
                            {badge.earned && (
                                <motion.div
                                    initial={{ scale: 0 }}
                                    animate={{ scale: 1 }}
                                    className="absolute -top-1 -right-1 w-5 h-5 bg-[#D4A537] rounded-full flex items-center justify-center"
                                >
                                    <span className="text-[#1A202C] text-xs font-bold">&#10003;</span>
                                </motion.div>
                            )}
                        </motion.div>
                    );
                })}
            </div>
        </div>
    );
}
